import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import GroupList from './screens/GroupList';
import { ConnectedCreateGroupScreen as CreateGroup } from './screens/CreateGroup';
import PoolList from 'features/SpilKlub/screens/PoolList';
import PoolDetails from 'features/SpilKlub/screens/PoolDetails';
import GroupEdit from 'features/SpilKlub/components/GroupEdit';

import useAuth from './state/useAuth';
import {
    CREATE_GROUP_SLUG,
    GROUP_EDIT_SLUG,
    POOL_LIST_SLUG,
    POOL_DETAILS_SLUG,
    doesScreenNeedLogin,
} from './screens/useScreens';

import './styles/utils.css';
import './styles/forms.css';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import { detectMobile } from 'utils/UiHelper';

const SwitchScreen = ({ screen, entityId, entityId2 }) => {
    const sharedProps = { entityId, entityId2 };

    if (screen === CREATE_GROUP_SLUG) {
        return <CreateGroup {...sharedProps} />;
    } else if (screen === POOL_LIST_SLUG) {
        return <PoolList {...sharedProps} />;
    } else if (screen === GROUP_EDIT_SLUG) {
        return <GroupEdit {...sharedProps} />;
    } else if (screen === POOL_DETAILS_SLUG) {
        return <PoolDetails {...sharedProps} />;
    } else {
        return <GroupList {...sharedProps} />;
    }
};

export const authHandler = (uiActions, screen, modalData = {}) => {
    const modalId = detectMobile() ? 'LOGIN_MOBILE' : 'LOGIN';

    uiActions.showModal(modalId, {
        stayOnPage: true,
        ...modalData,
    });
};

const SpilKlub = ({ screen, userId, entityId, entityId2, uiActions, auth }) => {
    const { setUserId } = useAuth();

    useEffect(
        () => {
            setUserId(userId);
        },
        [userId]
    );

    useEffect(
        () => {
            if (
                screen &&
                !doesScreenNeedLogin(screen) &&
                !userId &&
                !auth.sessionPending
            ) {
                authHandler(uiActions, screen);
            }
        },
        [auth.sessionPending, screen, userId]
    );

    return (
        <SwitchScreen
            screen={screen}
            entityId={entityId}
            entityId2={entityId2}
        />
    );
};

function mapStateToProps(state) {
    return { userId: state.auth?.user?.userId, auth: state.auth };
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpilKlub);
